// Cherry Wishlist - persistencia localStorage + sync Klaviyo
(() => {
  const KEY = 'qora_wishlist_v1';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  };
  const write = (list) => {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('cherry:wishlist-changed', { detail: { list } }));
  };

  const isIn = (handle) => read().some((p) => p.handle === handle);

  const toggle = (item) => {
    let list = read();
    const idx = list.findIndex((p) => p.handle === item.handle);
    let added = false;
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.unshift({ ...item, added_at: Date.now() });
      added = true;
    }
    write(list);
    syncKlaviyo(item, added);
    return added;
  };

  const syncKlaviyo = (item, added) => {
    if (typeof window.klaviyo === 'undefined') return;
    try {
      window.klaviyo.push([
        'track',
        added ? 'Added to Wishlist' : 'Removed from Wishlist',
        {
          ProductName: item.title,
          ProductHandle: item.handle,
          ProductURL: window.location.origin + item.url,
          ImageURL: item.image,
          Price: parseFloat(item.price || 0),
        },
      ]);
    } catch (e) {}
  };

  // Actualizar UI de un botón
  const updateButton = (btn) => {
    const handle = btn.dataset.cherryHandle;
    if (!handle) return;
    if (isIn(handle)) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Quitar de favoritos');
    } else {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Agregar a favoritos');
    }
  };

  const refreshAllButtons = () => {
    document.querySelectorAll('[data-cherry-wishlist-toggle]').forEach(updateButton);
  };

  const refreshBadge = () => {
    const count = read().length;
    document.querySelectorAll('[data-cherry-wishlist-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  };

  // Click handler delegated (capture phase so it runs ANTES de stopPropagation inline)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cherry-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const item = {
      handle: btn.dataset.cherryHandle,
      title: btn.dataset.cherryTitle,
      price: btn.dataset.cherryPrice,
      image: btn.dataset.cherryImage,
      url: btn.dataset.cherryUrl,
    };
    if (!item.handle) return;
    toggle(item);
    updateButton(btn);
    refreshBadge();
  }, true);

  // Render lista en la página wishlist
  const renderList = () => {
    const container = document.querySelector('[data-cherry-wishlist-list]');
    const empty = document.querySelector('[data-cherry-wishlist-empty]');
    if (!container) return;
    const list = read();
    if (list.length === 0) {
      container.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    container.innerHTML = list.map((p) => {
      const hasImage = p.image && !p.image.includes('placeholder') && p.image !== 'undefined';
      const img = hasImage
        ? `<img src="${p.image}" alt="${p.title}" loading="lazy" onerror="this.style.display='none'">`
        : `<div style="width:100%;height:100%;display:grid;place-items:center;color:var(--cherry-mute);"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5-9 9"/></svg></div>`;
      return `
        <article class="cherry-wishlist__card">
          <a class="cherry-wishlist__card-img" href="${p.url}">${img}</a>
          <div class="cherry-wishlist__card-body">
            <a class="cherry-wishlist__card-title" href="${p.url}">${p.title}</a>
            <div class="cherry-wishlist__card-price">$ ${p.price}</div>
            <div class="cherry-wishlist__card-actions">
              <a class="cherry-btn" href="${p.url}">Ver</a>
              <button type="button" class="cherry-wishlist__remove" data-cherry-wishlist-remove="${p.handle}">Quitar</button>
            </div>
          </div>
        </article>
      `;
    }).join('');
  };

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cherry-wishlist-remove]');
    if (!rm) return;
    const handle = rm.dataset.cherryWishlistRemove;
    let list = read();
    list = list.filter((p) => p.handle !== handle);
    write(list);
    renderList();
    refreshAllButtons();
    refreshBadge();
  });

  document.addEventListener('cherry:wishlist-changed', () => {
    renderList();
  });

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    refreshAllButtons();
    refreshBadge();
    renderList();
  });

  // Exponer API global por si otros componentes la necesitan
  window.qoraWishlist = { read, toggle, isIn, refresh: refreshAllButtons };
})();
